import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ensure } from 'components/sharpr/ensure/ensure';
import moment from 'moment';

export function IntegrationServicenowListingRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.IntegrationServicenowListing', {
		url: '/admin/integrations/servicenow',
		controllerAs: 'vm',
		controller: IntegrationServicenowListingCtrl,
		permission: ['manage_servicenow'],
		templateUrl: '/ng/hub/Integration/Servicenow/Listing/IntegrationServicenowListingCtrl.html?' + window.BUILD,
		resolve: {
			style: () => AssetManager.css('/ng/hub/Integration/Servicenow/Listing/IntegrationServicenowListingCtrl.css'),
			$title: () => 'ServiceNow Integrations',
		},
	});
}

export class IntegrationServicenowListingCtrl {
	constructor(Api, modal, $filter, $timeout, Identity) {
		'ngInject';
		this.$timeout = $timeout;
		this.modal = modal;
		this.Api = Api;
		this.listingEndpoint = '/credentials?type=servicenow&client_id=' + Identity.currentClient().id;
		this.dateFormat = $filter('shDate');
		this.columns = [
			{ field: 'username', label: 'Username', sortable: false },
			{ field: 'created', label: 'Created', sortable: false },
			{ field: 'last_sync', label: 'Last Run', sortable: false },
			{ field: 'next_sync', label: 'Next Run', sortable: false },
		];
		this.actions = [
			{ label: null, icon: 'pencil', callback: this.addEdit.bind(this) },
			{ label: null, icon: 'trash2', callback: this.delete.bind(this) },
		];
		this.filters = {};

		this.formatIntegrationsTable = this.formatIntegrationsTable.bind(this);
	}

	reload() {
		this.$timeout(() => {
			this.filters.cb = (+new Date() - 1487628121261).toString(36);
		});
	}

	addEdit(record = false) {
		const reload = this.reload.bind(this);
		this.modal
			.state('hub.loggedin.IntegrationServicenowAddEdit', {
				params: { integration_id: record.id || false },
				heading: record ? 'Edit Integration' : 'Add Integration',
				width: 650,
				height: 'full',
			})
			.then(reload, reload);
	}

	delete(record) {
		this.Api.delete(`/v2/credentials/${record.id}`).then(() => {
			this.filters.cb = (+new Date() - 1487628121261).toString(36);
		});
	}

	formatIntegrationsTable(result) {
		ensure.array(result.data).forEach(record => {
			['created', 'last_sync', 'next_sync'].forEach(key => {
				if (!record[key]) {
					record[key] = 'None';
				} else {
					record[key] = this.dateFormat(record[key], 'long');
				}
			});
		});
		return result;
	}
}
